// extracted by mini-css-extract-plugin
export var about = "about-module--about--H9dbg";
export var article = "about-module--article--2o02U";
export var img = "about-module--img--ZCaQk";